import { useEffect, useState } from "react";

const PREFIX = "chat-app-";

export default function useLocalStorage(key, initialValue) {
  const prefixedKey = PREFIX + key;
  const [value, setValue] = useState(() => {
    try {
      const jsonValue = localStorage.getItem(prefixedKey);
      if (jsonValue !== undefined && jsonValue !== null) {
        return JSON.parse(jsonValue);
      }
    } catch (e) {
      // Handle invalid JSON value
      console.log("Error: " + e);
    }

    if (typeof initialValue === "function") {
      return initialValue();
    } else {
      return initialValue;
    }
  });

  useEffect(() => {
    localStorage.setItem(prefixedKey, JSON.stringify(value));
  }, [prefixedKey, value]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      // Clear the entire local storage when the page is about to be unloaded
      localStorage.clear();
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return [value, setValue];
}
